export default __webpack_public_path__ + "static/reparation.maro-932ace07b9b1421a1a56cb0d0d32740f.svg";